import { render, staticRenderFns } from "./VaccinePricingAndDoseDistributionCampaignEdit.vue?vue&type=template&id=072cbfdf&"
import script from "./VaccinePricingAndDoseDistributionCampaignEdit.vue?vue&type=script&lang=js&"
export * from "./VaccinePricingAndDoseDistributionCampaignEdit.vue?vue&type=script&lang=js&"
import style0 from "./VaccinePricingAndDoseDistributionCampaignEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports